module.exports = __webpack_public_path__ + "img/immoby-horizontal-logo.8894ed55.svg";